import React from 'react'
import StringFilterItem from '@/components/pages/NewDatasetJobPage/StringFilterItem'
import {CircularProgress, List} from '@mui/material'
import NewJobApiError from '@/components/pages/NewDatasetJobPage/NewJobApiError'
import {StyledCenteredDiv} from '@/components/pages/NewDatasetJobPage/StyledCenteredDiv'
import {StringFilterOptions} from '@/components/pages/NewDatasetJobPage/types'

type NewJobStringFiltersProps = {
    stringFilters?: StringFilterOptions[]
    selectedFilters: Record<string, string[]>
    onFilterSelect: (filterName: string, checked: boolean, filterVal: any) => void
    isLoading: boolean
    error?: boolean
}

const NewJobStringFilters = ({stringFilters, selectedFilters, onFilterSelect, isLoading, error}: NewJobStringFiltersProps) => {

    if(isLoading) {
        return <StyledCenteredDiv><CircularProgress /></StyledCenteredDiv>
    }

    if(error) {
        return <NewJobApiError text="Unable to load filters"/>
    }

    if(stringFilters === undefined) {
        return <div>Select Database to load string filters</div>
    }

    if(stringFilters.length === 0) {
        return <div>No string filters available</div>
    }

    return <List>
        {stringFilters?.map((stringFilter: StringFilterOptions, idx: number) => (
            <StringFilterItem key={'string-filter-' + idx} 
                stringFilterOpts={stringFilter} 
                checked={!!selectedFilters[stringFilter.name]}
                selectedValues={selectedFilters[stringFilter.name]}
                onFilterSelect={onFilterSelect} />
        ))}
    </List>
}

export default NewJobStringFilters